<template>
  <modal :value="showFlag" @on-cancel="clearDataModal" title="高级搜索" class="advanced" width="600">
    <div class="advanced_content">
      <div class="list">
        <span class="title">时间</span>
        <div v-for="(item,index) in moreData" :key="index" class="list_option">
          <Select v-model="item.selectValue" size="small" style="width:120px;margin-right:10px;">
            <Option v-for="time in condition.receiveList" :value="time.value" :key="time.value">
              {{time.label}}
            </Option>
          </Select>
          <DatePicker v-model="item.startTime" type="datetime" format="yyyy-MM-dd HH:mm"
                      placeholder="选择开始时间" size="small" style="width:140px;margin-right:10px;"></DatePicker>
          <DatePicker v-model="item.endTime" type="datetime" format="yyyy-MM-dd HH:mm"
                      placeholder="结束时间" size="small" style="width:140px;"></DatePicker>

          <Select v-if="item.add" v-model="item.linkMode" size="small" placeholder="请选择条件"
                  style="width:100px;margin-left:10px;">
            <Option value="and">并且</Option>
            <Option value="or">或者</Option>
          </Select>

          <span v-if="item.delete" class="delete_condition" @click="deleteTimeOption(index)">
            <Icon type="close-circled"></Icon>
          </span>
        </div>

        <!-- 添加 -->
        <span class="add_condition" @click="addTimeOption()">
            <Icon type="plus-circled"></Icon>
        </span>
      </div>

      <div class="list">
        <span class="title">更多</span>
        <div v-for="(item,index) in moreOptionData" :key="index" class="list_option">
          <Select v-model="item.selectValue" size="small"
                  style="width:120px;margin-right:10px;">
            <Option @click.native="changeMoreValue(index,more.value)" v-for="(more,indexes) in filterOption"
                    :value="more.value"
                    :key="indexes">{{more.label}}
            </Option>
          </Select>

          <!-- 条件状态 -->
          <Select v-if="item.moreOptionVisibiel.kind" v-model="item.kind" size="small"
                  style="width:120px;margin-right:10px;">
            <Option v-for="kind in item.moreKind" :value="kind.value"
                    :key="kind.value">{{kind.label}}
            </Option>
          </Select>

          <!-- 条件 select -->
          <Select v-if="item.moreOptionVisibiel.result" v-model="item.select" size="small"
                  style="width:140px;margin-right:10px;">
            <Option v-for="select in item.moreResult" :value="select.value"
                    :key="select.label">{{select.label}}
            </Option>
          </Select>

          <!-- 人员选择 -->
          <Select v-if="item.moreOptionVisibiel.staffId" v-model="item.staffId" filterable remote :remote-method="getStaffApi" size="small" style="width:200px;">
            <Option v-for="(option, index) in staffResult" :value="option.value" :key="index">{{option.label}}</Option>
          </Select>

          <!-- 条件 input -->
          <i-Input ref="inputValue" v-if="item.moreOptionVisibiel.input" v-model="item.input" placeholder="请输入..."
                   size="small" style="width:140px;margin-right:10px;">
          </i-Input>

          <Select v-if="item.add" v-model="item.linkMode" size="small" placeholder="请选择条件"
                  style="width:100px;margin-left:10px;">
            <Option value="and">并且</Option>
            <Option value="or">或者</Option>
          </Select>

          <span v-if="item.delete" class="delete_condition" @click="deleteMoreOption(index)">
            <Icon type="close-circled"></Icon>
          </span>

        </div>

        <!-- 添加 -->
        <span class="add_condition" @click="addMoreOption">
            <Icon type="plus-circled"></Icon>
        </span>

      </div>

    </div>
    <div slot="footer" style="text-align: center;height:30px;">
      <i-Input v-model="bookMark" placeholder="请输入书签名" style="width:200px;float:left;margin-right:4px;"></i-Input>
      <Button type="primary" @click="saveBookMark" style="float:left;" >存为书签</Button>
      <Button type="primary" @click="closeModal(false)" style="float:right;">搜索</Button>
    </div>
  </modal>
</template>

<script>
  import {mapGetters} from 'vuex'
  import timeUtil from '../../common/time-util'

  export default {
    name: "advanced-search",
    props: {
      value: {
        type: Boolean
      }
    },
    computed: {
      ...mapGetters(['condition', 'moreOption', 'pageDict', 'sparesql']),

      showFlag() {
        return this.value
      },

      //过滤等多搜索
      filterOption() {
        let data = this.moreOption.type.filter(item => {
          return item.value != 'more'
        })
        return data
      },
    },
    data() {
      return {
        advancedShow: false,
        moreData: [],
        moreOptionData: [
          {
            selectValue: '1',
            kind: '=',
            select: '',
            input: '',
            delete: false,
            add: false,
            linkMode: '',
            staffId:'',
            moreOptionVisibiel: {
              input: false,
              result: false,
              kind: false,
              staffId:false,
            },
            moreKind: [
              {
                value: '=',
                label: '等于'
              }
            ],
            moreResult: [],
          }
        ],
        bookMark:'',
        staffResult:[],
      }
    },
    methods: {
      //保存
      closeModal(flag) {
        let timeType = {
          "1": "CREATETIME",
          "2": "RECEIVETIME",
          "3": "APPOINTTIME",
          "4": "COMESHOPTIME",
          "5": "SUCCESSTIME",
          "6": "TRACETIME",
          "7": "UPDATETIME",
        }

        let filterMore = ''
        if(this.moreOptionData.length){
          if (this.moreOptionData[0].add) {
            this.moreOptionData.map(item => {
              console.log(item)
              if (item.select !== '') {
                if (item.kind == 'like') {
                  filterMore += ` ${item.selectValue} ${item.kind} '%${item.select}%' ${item.linkMode}`
                } else {
                  filterMore += ` ${item.selectValue} ${item.kind} '${item.select}' ${item.linkMode}`
                }
              } else if(item.staffId !== ''){
                if (item.kind == 'like') {
                  filterMore = ` ${item.selectValue} ${item.kind} '%${item.staffId}%' ${item.linkMode}`
                } else if(item.kind == 'is Null') {
                  filterMore = ` ( ${item.selectValue} IS NULL OR ${item.selectValue} = '' ) `
                } else {
                  filterMore = ` ${item.selectValue} ${item.kind} ${item.staffId} ${item.linkMode}`
                }
              } else if (item.input) {
                if (item.kind == 'like') {
                  filterMore += ` ${item.selectValue} ${item.kind} '%${item.input}%' ${item.linkMode}`
                } else {
                  filterMore += ` ${item.selectValue} ${item.kind} '${item.input}' ${item.linkMode}`
                }
              }
            })
          } else {
            if (this.moreOptionData[0].select !== '') {
              if (this.moreOptionData[0].kind == 'like') {
                filterMore = ` ${this.moreOptionData[0].selectValue} ${this.moreOptionData[0].kind} '%${this.moreOptionData[0].select}%'  ${this.moreOptionData[0].linkMode}`
              } else {
                filterMore = ` ${this.moreOptionData[0].selectValue} ${this.moreOptionData[0].kind} '${this.moreOptionData[0].select}'  ${this.moreOptionData[0].linkMode}`
              }
            }else if(this.moreOptionData[0].staffId !== ''){
              if (this.moreOptionData[0].kind == 'like') {
                filterMore = ` ${this.moreOptionData[0].selectValue} ${this.moreOptionData[0].kind} '%${this.moreOptionData[0].staffId}%' ${this.moreOptionData[0].linkMode}`
              } else if(this.moreOptionData[0].kind == 'is Null') {
                filterMore = ` ( ${this.moreOptionData[0].selectValue} IS NULL OR ${this.moreOptionData[0].selectValue} = '' ) `
              } else {
                filterMore = ` ${this.moreOptionData[0].selectValue} ${this.moreOptionData[0].kind} ${this.moreOptionData[0].staffId} ${this.moreOptionData[0].linkMode}`
              }
            }  else if (this.moreOptionData[0].input) {
              if (this.moreOptionData[0].kind == 'like') {
                filterMore = ` ${this.moreOptionData[0].selectValue} ${this.moreOptionData[0].kind} '%${this.moreOptionData[0].input}%'  ${this.moreOptionData[0].linkMode}`
              } else {
                filterMore = ` ${this.moreOptionData[0].selectValue} ${this.moreOptionData[0].kind} '${this.moreOptionData[0].input}'  ${this.moreOptionData[0].linkMode}`
              }
            }
          }
        }
        let str = ''
        let moreStr = this.moreData
        if(moreStr.length){
          if (moreStr[0].add) {
            moreStr.map(item => {
              str += ` info.${timeType[item.selectValue]} >= ${timeUtil.getTimeStamp(item.startTime)} and info.${timeType[item.selectValue]} <= ${timeUtil.getTimeStampPlus59s(item.endTime)} ${item.linkMode} `
            })
          } else {
            if (moreStr[0].startTime || moreStr[0].startTime) {
              str = ` info.${timeType[moreStr[0].selectValue]} >= ${timeUtil.getTimeStamp(moreStr[0].startTime)} and info.${timeType[moreStr[0].selectValue]} <= ${timeUtil.getTimeStampPlus59s(moreStr[0].endTime)}`
            }
          }
        }

        let sqlStr = ''

        if (!filterMore && !str) {
          return false
        }
        if (filterMore && str) {
          sqlStr = `${str} and ${filterMore}`
        } else if (filterMore && !str) {
          sqlStr = `${filterMore}`
        } else if (!filterMore && str) {
          sqlStr = `${str}`
        }
        this.$store.commit('setSparesql', sqlStr)
        if(!flag){
          this.$emit('close-modal', false)
          this.$bus.emit('pull-kz-data')
        }
      },

      //关闭 清空数据
      clearDataModal() {
        this.$emit('close-modal', false)
        this.bookMark = ''
      },

      //时间类型 添加
      addTimeOption() {
        if(this.moreData.length){
          let arrLength = this.moreData.length - 1
          this.$set(this.moreData[arrLength], 'add', true)
          this.$set(this.moreData[arrLength], 'linkMode', 'and')
        }

        this.moreData.push({
          selectValue: '',
          startTime: '',
          endTime: '',
          linkMode: '',
          add: false,
          delete: true,
        })
        this.$forceUpdate()
      },

      //时间类型 删除
      deleteTimeOption(index) {
        if ((index + 1) == this.moreData.length) {
          this.$set(this.moreData[index - 1], 'add', false)
          this.$set(this.moreData[index - 1], 'linkMode', '')
        } else {
          this.$set(this.moreData[index], 'add', false)
          this.$set(this.moreData[index], 'linkMode', '')
        }

        this.moreData.splice(index, 1)
        this.$forceUpdate()
      },

      //更多删除
      deleteMoreOption(index) {
        if ((index + 1) == this.moreOptionData.length) {
          this.$set(this.moreOptionData[index - 1], 'add', false)
          this.$set(this.moreOptionData[index - 1], 'linkMode', '')
        } else {
          this.$set(this.moreOptionData[index], 'add', false)
          this.$set(this.moreOptionData[index], 'linkMode', '')
        }

        this.moreOptionData.splice(index, 1)
        this.$forceUpdate()
      },

      //更多选项增加
      addMoreOption() {
        let arrLength = this.moreOptionData.length - 1
        this.$set(this.moreOptionData[arrLength], 'add', true)
        this.$set(this.moreOptionData[arrLength], 'linkMode', 'and')
        this.moreOptionData.push({
          selectValue: '1',
          kind: '=',
          select: '',
          input: '',
          delete: true,
          add: false,
          linkMode: '',
          staffId:'',
          moreOptionVisibiel: {
            input: false,
            result: false,
            kind: false,
            staffId:false,
          },
          moreKind: [
            {
              value: '=',
              label: '等于'
            }
          ],
          moreResult: [],
        })
        this.$forceUpdate()
      },

      //更多选项
      changeMoreValue(index, val) {
        this.moreOptionClear(index)
        switch (val) {
          case '1':
            this.changeStatus(index, false, false, false, false)
            break
          case 'info.STATUSID':
            this.changeKind(index, [
              {
                label: '等于',
                value: '='
              }])
            this.responeSelectData(index, this.changeSelectData(JSON.parse(JSON.stringify(this.pageDict.statusMap))))
            this.changeStatus(index, true, true, false, false)
            break
          case 'det.ZXSTYLE':
            this.changeKind(index, [{
              label: '等于',
              value: '='
            }])
            this.responeSelectData(index, this.changeSelectData(JSON.parse(JSON.stringify(this.pageDict.commonMap.zxStyle))))
            this.changeStatus(index, true, true, false, false)
            break
          case 'det.YSRANGE':
            this.changeKind(index, [{
              label: '等于',
              value: '='
            }])
            this.responeSelectData(index, this.changeSelectData(JSON.parse(JSON.stringify(this.pageDict.commonMap.ysRange))).slice(1))
            this.changeStatus(index, true, true, false, false)
            break
          case 'det.MARRYTIME':
            this.changeKind(index, [{
              label: '等于',
              value: '='
            }])
            this.responeSelectData(index, this.changeSelectData(JSON.parse(JSON.stringify(this.pageDict.commonMap.marryTime))).slice(1))
            this.changeStatus(index, true, true, false, false)
            break
          case 'info.ALLOTTYPE':
            this.changeKind(index, [{
              label: '等于',
              value: '='
            }])
            let data = [
              {
                value:'1',
                label:'系统自动分配'
              },
              {
                value:'2',
                label:'手动分配'
              },
              {
                value:'3',
                label:'录入时指定'
              },
              {
                value:'4',
                label:'主管转移'
              },
              {
                value:'5',
                label:'excel导入'
              },
            ]
            this.responeSelectData(index, data)
            this.changeStatus(index, true, true, false, false)
            break
          case 'det.INVALIDLABEL':
            this.changeKind(index, [{
              label: '相似于',
              value: 'like'
            }])
            this.responeSelectData(index, this.changeWxData(JSON.parse(JSON.stringify(this.pageDict.commonMap.invalidReason))))
            this.changeStatus(index, true, true, false, false)
            break
          case 'det.YXLEVEL':
            this.changeKind(index, [{
              label: '等于',
              value: '='
            }])
            this.responeSelectData(index, this.filterData())
            this.changeStatus(index, true, true, false, false)
            break
          case 'info.ID':
            this.changeKind(index, [{
              label: '等于',
              value: '='
            }])
            this.changeStatus(index, true, false, true, false)
            break
          case 'det.AMOUNT':
            this.changeKind(index, [
              {
                label: '等于',
                value: '='
              },
              {
                label: '小于',
                value: '<'
              },
              {
                label: '小于等于',
                value: '<='
              },
              {
                label: '大于',
                value: '>'
              },
              {
                label: '大于等于',
                value: '>='
              }])
            this.changeStatus(index, true, false, true, false)
            break
          case 'info.SEX':
            this.responeSelectData(index, [
              {
                value: '1',
                label: '先生'
              },
              {
                value: '2',
                label: '女士'
              },
              {
                value: '0',
                label: '未知'
              },
            ])
            this.changeKind(index, [{
              label: '等于',
              value: '='
            }])
            this.changeStatus(index, true, true, false, false)
            break
          case 'info.WEFLAG':
            this.responeSelectData(index, [
              {
                value: '1',
                label: '已添加'
              },
              {
                value: '2',
                label: '没加上'
              },
              {
                value: '0',
                label: '未标记'
              },
            ])
            this.changeKind(index, [{
              label: '等于',
              value: '='
            }])
            this.changeStatus(index, true, true, false, false)
            break
          case 'info.KZPHONE_FLAG':
            this.responeSelectData(index, [
              {
                value: '0',
                label: '未拨打'
              },
              {
                value: '1',
                label: '已拨打'
              },
              {
                value: '2',
                label: '已接听'
              },
              {
                label: '3',
                value: '未接听'
              },
            ])
            this.changeKind(index, [{
              label: '等于',
              value: '='
            }])
            this.changeStatus(index, true, true, false, false)
            break
          case 'det.ZXSTYLE':
            this.changeKind(index, [{
              label: '等于',
              value: '='
            }])
            this.changeStatus(index, true, false, true, false)
            break
          case 'det.YSRANGE':
            this.changeKind(index, [{
              label: '等于',
              value: '='
            }])
            this.changeStatus(index, true, false, true, false)
            break
          case 'info.PROMOTORID':
            this.changeKind(index,[
              {
                label: '等于',
                value: '='
              },
              {
                label: '为空',
                value: 'is Null'
              },
            ])
            this.changeStatus(index,true, false, false,true)
            break
          case 'info.COLLECTORID':
            this.changeKind(index,[
              {
                label: '等于',
                value: '='
              },
              {
                label: '为空',
                value: 'is Null'
              },
            ])
            this.changeStatus(index,true, false, false,true)
            break
          case 'info.APPOINTORID':
            this.changeKind(index,[
              {
                label: '等于',
                value: '='
              },
              {
                label: '为空',
                value: 'is Null'
              },
            ])
            this.changeStatus(index,true, false, false,true)
            break
          case 'info.RECEPTORID':
            this.changeKind(index,[
              {
                label: '等于',
                value: '='
              },
              {
                label: '为空',
                value: 'is Null'
              },
            ])
            this.changeStatus(index,true, false, false,true)
            break
          default:
            this.changeKind(index, [
              {
                label: '等于',
                value: '='
              },
              {
                label: '相似于',
                value: 'like'
              }
            ])
            this.changeStatus(index, true, false, true, false)
        }
      },

      //更多选项切换 清空数据
      moreOptionClear(index) {
        this.$set(this.moreOptionData[index], 'kind', '=')
        this.$set(this.moreOptionData[index], 'select', '')
        this.$set(this.moreOptionData[index], 'input', '')
        this.$set(this.moreOptionData[index], 'staffId', '')
        this.$set(this.moreOptionData[index], 'moreResult', [])
      },

      //修改搜索状态
      changeStatus(index, kind, result, input, staff) {
        this.moreOptionData[index].moreOptionVisibiel = {
          kind: kind,
          result: result,
          input: input,
          staffId:staff,
        }
      },

      //修改下拉数据类型
      changeSelectData(data) {
        let handleData = []
        if (!data.length) {
          for (let item in data) {
            handleData.push({
              value: data[item].statusId,
              label: data[item].statusName,
            })
          }
        } else {
          handleData = data.map(item => {
            return {
              value: item.dicCode,
              label: item.dicName,
            }
          })
        }
        return handleData
      },

      //修改下拉数据类型
      changeWxData(data) {
        let handleData = []
        if (!data.length) {
          for (let item in data) {
            handleData.push({
              value: data[item].dicName,
              label: data[item].dicName,
            })
          }
        } else {
          handleData = data.map(item => {
            return {
              value: item.dicName,
              label: item.dicName,
            }
          })
        }
        return handleData
      },

      //相应修改下拉数据
      responeSelectData(index, data) {
        this.$set(this.moreOptionData[index], 'moreResult', data)
      },

      //修改条件
      changeKind(index, data) {
        this.$set(this.moreOptionData[index], 'moreKind', data)
      },

      filterData() {
        let data = this.changeSelectData(JSON.parse(JSON.stringify(this.pageDict.commonMap.yxLevel))).slice(1)
        return data
      },

      //远程请求下拉
      getStaffApi(query){
        this.$http.get('staff/search_by_key',{
          params:{
            key:query,
          }
        }).then(data=>{
          if(data.code == 100000){
            this.staffResult = data.data.map(item=>{
              return {
                value:item.id,
                label:item.nickName,
              }
            })
          }else{
            this.$Message.error(data.msg)
          }
        })
      },

      //存为书签
      saveBookMark(){
        if(!this.bookMark){
          this.$Message.warning('请输入书签')
          return false
        }
        this.closeModal(true)
        if(!this.sparesql){
          this.$Message.warning('请先选择条件')
        }

        //存入本地localStore
        let localBook = JSON.parse(localStorage.getItem('book_mark'))
        let bookArray = []
        if(localBook){
          bookArray = localBook
        }
        bookArray.push({
          bookName:this.bookMark,
          bookFilter:this.sparesql
        })
        localStorage.setItem('book_mark',JSON.stringify(bookArray))

        this.$emit('close-modal', false)
        this.$bus.emit('update_book_mark')
        this.$bus.emit('pull-kz-data')

        //清空条件
        this.clearDataModal()
        this.bookMark = ''
      },
    }
  }
</script>

<style lang="less">
  .advanced {
    .advanced_content {
      .list {
        margin-bottom: 20px;
        max-height:200px;
        overflow-x: scroll;
        .title {
          display: block;
          color: #ccc;
          margin-bottom: 4px;
        }
        .list_option {
          display: flex;
          align-items: end;
          margin: 10px 0;
        }
      }
      .list_condition {
        margin-bottom: 20px;
        .title {
          display: block;
          color: #ccc;
          margin-bottom: 4px;
        }
        .list_option {
          display: flex;
          align-items: flex-end;
        }
      }
    }

    .add_condition {
      display: block;
      text-align: center;
      width: 100px;
      margin: 10px auto;
      font-size: 18px;
      cursor: pointer;
    }
    .delete_condition {
      margin-left: 10px;
      font-size: 18px;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/render-components/advanced-search.vue